import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UrlAddDomainPipe } from "libraries/pipes/url-with-domain/url-add-domain.pipe";

@NgModule({
    declarations: [UrlAddDomainPipe],
    exports: [
        UrlAddDomainPipe,
    ],
    imports: [
        CommonModule
    ]
})
export class UrlWithDomainModule { }
